export const entityTypes = {
  PRODUCT: 'product',
  PATTERN: 'pattern',
  ARTICLE: 'article'
};
